import * as React from "react";
import { SVGProps } from "react";

const Ontology = (props: SVGProps<SVGSVGElement>) => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 2691 2626" {...props}>
    <path
      fill="#2da7bf"
      d="M.71 1151.2V56.2l2220 2236c-46 38-600 481-1260 284-573-172-980-756-960-1425Zm2688 328 3 1087-2227-2228c46-39 599-484 1259-289 576 171 985 757 964 1430Z"
    />
  </svg>
);

export default Ontology;
